import Resource from '@/api/resources/Resource'

class UserInformationResource extends Resource {
    async get() {
        const response = await this.axios.get('/userInformation')
        return response.data
    }

    async patchUser(userData) {
        const response = await this.axios.patch(`/userInformation`, userData)
        return response.data
    }
}

export default new UserInformationResource()
